import type { CreateBranchType } from '@readme/iso/src/branches/mock';

/**
 * Returns an "empty" branch object filled with default values. Used when
 * creating a new branch.
 */
export function createDefaultBranch<Keys extends CreateBranchType>(keys: Partial<Keys>) {
  return {
    base: '',
    name: '',
    ...keys,
  } satisfies CreateBranchType;
}
